import { createAction } from '@reduxjs/toolkit';

export type PaginationReducerPayload = {
  statusIndex: number;
  numberOfPages: number;
  rowsPerPage: number;
  startSlice: number;
  endSlice: number;
  totalCount: number;
};

export type PaginationPayload = {
  statusIndex: number;
};
export type PaginationReducerInitPayload = Pick<
  PaginationReducerPayload,
  'endSlice' | 'rowsPerPage' | 'endSlice' | 'statusIndex' | 'startSlice'
>;

// Docs: https://redux-toolkit.js.org/api/createAction
export const tablePaginationIncrement = createAction<PaginationPayload>(
  'pagination/INCREMENT',
);

export const tablePaginationDecrement = createAction<PaginationPayload>(
  'pagination/DECREMENT',
);

export const tablePaginationCurrent =
  createAction<PaginationPayload>('pagination/CURRENT');

export const tablePaginationInitstate =
  createAction<PaginationReducerInitPayload>('pagination/INITSTATE');
